import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id', 
  { clinic: ['nylas_account_id', 'widget_token'] }, 
  'email', 
  'first_name', 
  'last_name', 
  'updated_at'
];

export const getProfile = asyncThunkWrapper({ 
  model: 'profile', 
  action: 'getProfile', 
  func: async () => {
    const response = await axios.get(`/profile`, { params: { attributes } });

    return response.data;
  } 
});
export const updateProfile = asyncThunkWrapper({ 
  model: 'profile', 
  action: 'updateProfile', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/profile`, { manager: { ...fields } });

    return { status: response.status, manager: { ...fields } };
  } 
});